import React from 'react';

const shimmerBase = {
  background:
    'linear-gradient(90deg, rgba(230,230,230,0.7) 25%, rgba(245,245,245,1) 37%, rgba(230,230,230,0.7) 63%)',
  backgroundSize: '400% 100%',
  animation: 'spinnerAbsoluteShimmer 1.5s ease-in-out infinite',
  borderRadius: 6,
};

const Skeleton = ({ style = {} }) => <div style={{ ...shimmerBase, ...style }} />;

const SpinnerAbsolute = () => {
  return (
    <div style={{ padding: 24, minHeight: '100vh', backgroundColor: '#f6f6f6' }}>
      <style>
        {`
          @keyframes spinnerAbsoluteShimmer {
            0% {
              background-position: 100% 0;
            }
            100% {
              background-position: 0 0;
            }
          }
        `}
      </style>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr',
          gap: 24,
          maxWidth: 1200,
          margin: '0 auto',
          alignItems: 'start',
        }}
      >
        <div>
          <Skeleton style={{ width: 140, height: 52, marginBottom: 20 }} />
          <Skeleton style={{ width: '100%', height: 350 }} />
        </div>

        <div>
          <Skeleton style={{ width: 120, height: 16, marginBottom: 16, marginLeft: 'auto' }} />
          <Skeleton style={{ width: '100%', aspectRatio: '16 / 9', marginBottom: 16 }} />
          <Skeleton style={{ width: 110, height: 12, marginBottom: 8 }} />
          <Skeleton style={{ width: 65, height: 10 }} />
        </div>
      </div>
    </div>
  );
};

export default React.memo(SpinnerAbsolute);
